// extracted by mini-css-extract-plugin
export default {"container":"WidgetApp_container__EQFmm"};